import { defineMessages } from 'react-intl';

export default defineMessages({
  additionalInformationTitle: {
    id: 'pricing.additionalInformation.title',
    defaultMessage: 'Additional information',
  },
  productIncludesTitle: {
    id: 'pricing.productIncludes.title',
    defaultMessage: 'Product includes',
  },
  systemRequirementsTitle: {
    id: 'pricing.systemRequirements.title',
    defaultMessage: 'System Requirements',
  },
});
